import React from "react";
import { Avatar, Card } from "antd";
import dayjs from "dayjs";

const ActivitiesCard = ({
  item,
}) => {

  return (
    <div className="flex flex-col gap-3">
      <Card
        key={item?.erw_id}
        className="rounded-xl dark-mode-card"
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <Avatar
              size={40}
              className="bg-gradient-to-br from-emerald-500 to-violet-500 overflow-hidden"
            >
              {item?.employee_initials}
            </Avatar>

            <div className="flex-1 min-w-0">
              <p className="font-medium text-[13px] title-text truncate">
                {item?.employee_name}
              </p>

              <p className="text-[11px] text-muted-foreground muted-text line-clamp-1 tracking-normal">
                {item?.reward_title}: {item?.erw_reason}
              </p>
            </div>
          </div>
 
          <div className="flex flex-col items-center justify-end shrink-0">
            <span className="rounded-xl border px-2 py-0.5 gradient emerald  text-white text-[11px] font-semibold">
              +{item?.erw_points_awarded} credits
            </span>

            <p className="text-[10px] text-muted-foreground muted-text mt-1 tracking-normal">
              {item?.erw_issued_at
                ? dayjs(item.erw_issued_at).format("YYYY-MM-DD")
                : ""}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};


export default ActivitiesCard;